"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function unregisterHttpPlugin(shaka) {
    var networkingEngine = shaka.net.NetworkingEngine;
    networkingEngine.unregisterScheme('http');
    networkingEngine.unregisterScheme('https');
}
exports.default = unregisterHttpPlugin;
//# sourceMappingURL=unregisterHttpPlugin.js.map